import { z } from 'zod';

export const apiErrorSchema = z.object({ error: z.string().min(1) }).strict();
export const healthSchema = z.object({ status: z.literal('ok') }).strict();
export type ApiError = z.infer<typeof apiErrorSchema>;
export type Health = z.infer<typeof healthSchema>;

export const responseIdSchema = z.uuidv7();
